import { useState, useEffect } from "react"
import {
    Form,
    FormGroup,
    Modal,
    Row,
    ModalBody,
    Label,
    Input
} from "reactstrap";
import { RoundedButton, ButtonColor, ButtonCorner } from "../../components/Buttons/RoundedButton";
import { successToast, errorToast } from "../../constants/toast";
import { useDeleteSelectedMutation } from "../../utilities/mutations/useDeleteSelectedMutation";
import { StructuralAccountType } from './StructuralAccountType';
import location from '../../assets/img/icons/common/location.png';
import subOrg from '../../assets/img/icons/common/subOrg.png';
import { SquareCheckbox } from "../../components/Inputs/SquareCheckbox/SquareCheckbox";
import PreventEnterSubmitForm from "../../components/Forms/PreventEnterSubmitForm";
import Button from "../../components/UIButton/UIButton";
import Spinner from "../../components/UISpinner/UISpinner";


function BulkDeleteModal({ isOpen, cancel, checkedItems, data, updateTreePostDelete, makeToast, deselectAll }) {

    const [isChecked, setIsChecked] = useState(false);
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { mutateAsync: deleteAsync, error: getError } = useDeleteSelectedMutation();
    const checkBoxClassName = "";

    useEffect(() => {
        if (data !== undefined) {
            for (var i = 0; i < checkedItems.length; i++) {
                var selectedAccount = data[checkedItems[i]];

                const structuralAccountTypeId = selectedAccount.data.structuralAccountTypeId;
                let icon;
                let altText;

                switch (structuralAccountTypeId) {
                    case StructuralAccountType.Suborg:
                        icon = subOrg;
                        altText = 'subOrg';
                        break;
                    case StructuralAccountType.Location:
                        icon = location;
                        altText = 'location';
                        break;
                    default:
                        icon = '❓';
                        altText = 'unknown';
                }

                items.push({
                    accountId: selectedAccount.accountId,
                    name: selectedAccount.data.name,
                    type: selectedAccount.data.structuralAccountTypeId,
                    icon: icon,
                    altText: altText
                });
            }
        }
        setIsLoading(false);
    }, []);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        var result = await deleteAsync(checkedItems);
        if (result.data.length === 0) {
            updateTreePostDelete(checkedItems);
            makeToast("Delete action succeeeded.", successToast);
            deselectAll();
        }
        else {
            makeToast("Error deleting the following account record(s): " + result.data, errorToast);
        }
    };

    return (
        <Modal size="lg" isOpen={isOpen}>
            <PreventEnterSubmitForm onSubmit={handleSubmit} className="text-center">
                <div className="delete-selected-hdr">
                    Confirm Deletion
                </div>
                <ModalBody>
                    {isLoading && <Spinner text="Deleting Orgs/Locations..." />}
                    {!isLoading && <>
                        <p>Are you sure you want to delete organizations and/or locations?</p>
                        <div className="delete-selection-container">
                            {items &&
                                items.map(function (item, i) {
                                    return (
                                        <div key={item.accountId} value={item.accountId}>
                                            <img src={item.icon} alt={item.altText} className="delete-modal-icon img-fluid"></img>
                                            {item.name}
                                        </div>

                                    )
                                })}</div>
                        <div className="d-flex align-items-center gap-7 bulk-delete-chk-container">
                            <SquareCheckbox
                                value={isChecked}
                                valueChangeHandler={handleCheckboxChange}
                                checkboxClassName={checkBoxClassName}
                                isDisabled={false}
                                label="Yes, I want to delete everything in this list."
                            />

                        </div>
                        <div className="bottom-border"></div>
                        <div>
                            <p className="warning-txt">WARNING:</p>
                            <p className="delete-warning-txt">*This is a permanent action. Deleted sub-organizations and locations cannot be restored. This action may affect user's access to menu items, printer profiles and other data</p>
                            <p><span className="warning-txt">NOTE: </span> Devices assigned to deleted locations will be reassigned to the HQ.</p>
                        </div>

                        <div className="gap-6 align-items-center text-center">
                            <Button
                                id="cancelButton"
                                variant="info"
                                size="medium"
                                onClick={cancel}
                            >Cancel</Button>
                            <Button
                                variant="submit"
                                size="medium"
                                disabled={!isChecked && !isLoading}
                            >Delete</Button>
                        </div>
                    </>}
                </ModalBody>
            </PreventEnterSubmitForm>
        </Modal>
    )
}

export default BulkDeleteModal;